export const orignalAppConfig = {
  appName: "Orignal 2026",
  appShortName: "Orignal 2026",
  mode: "production",
  defaultLocale: "fr",
  supportedLocales: ["fr", "en"],
  phaseLabel: { fr: "En fonction 0.71.0", en: "Live 0.71.0" },
  demoBanner: {
    fr: "Préparation de la chasse 2026 · Portneuf · Secteur 4",
    en: "Getting ready for hunt 2026 · Portneuf · Sector 4",
  },
  roles: [
    { id: "member", labelFr: "Membre", labelEn: "Member", icon: "🌲" },
    { id: "admin", labelFr: "Administrateur", labelEn: "Administrator", icon: "🧭" },
  ],
  navGroups: [
    {
      id: "main",
      labelFr: "Principal",
      labelEn: "Main",
      roles: ["member", "admin"],
      items: [
        { id: "today", to: "/aujourdhui", labelFr: "Accueil", labelEn: "Home", icon: "🌅", end: true },
        { id: "territory", to: "/territoire", labelFr: "Territoire", labelEn: "Territory", icon: "🗺️" },
        { id: "hunt", to: "/chasse-2026", labelFr: "Chasse 2026", labelEn: "Hunt 2026", icon: "🦌" },
        { id: "prep", to: "/preparation", labelFr: "Préparation", labelEn: "Prep", icon: "✓" },
        { id: "tasks", to: "/taches", labelFr: "Tâches", labelEn: "Tasks", icon: "☑" },
        { id: "expenses", to: "/depenses", labelFr: "Dépenses", labelEn: "Expenses", icon: "$" },
        { id: "photos", to: "/photos", labelFr: "Photos", labelEn: "Photos", icon: "📷" },
        { id: "group", to: "/groupe", labelFr: "Groupe", labelEn: "Group", icon: "👥" },
      ],
    },
  ],
};

export const POINT_CATEGORIES = [
  "orignal",
  "traces",
  "feces",
  "frottage",
  "souille",
  "passage",
  "sentier",
  "zone_nourriciere",
  "eau",
  "acces",
  "stationnement",
  "chemin",
  "obstacle",
  "position",
  "revoir",
  "cache",
  "observation",
  "camp",
  "autre",
];

export const STRATEGIC_CATEGORIES = [
  "orignal",
  "traces",
  "feces",
  "frottage",
  "souille",
  "passage",
  "sentier",
  "zone_nourriciere",
  "eau",
  "acces",
  "stationnement",
  "chemin",
  "obstacle",
  "position",
  "revoir",
  "cache",
  "autre",
];

export const PHOTO_CATEGORIES = [
  "territoire",
  "chemin",
  "camp",
  "groupe",
  "observation",
  "traces",
  "equipement",
  "nourriture",
  "souvenir",
  "vehicule",
  "chalet",
  "a_classer",
  "autre",
];

export const EXPENSE_CATEGORIES = [
  "nourriture",
  "boissons_communes",
  "essence_commune",
  "hebergement",
  "materiel",
  "glace",
  "eau",
  "transport",
  "autre",
];

export const MESSAGE_CHANNELS = ["general", "territoire", "bouffe", "organisation", "photos"];
